/**
 * Business verification (KYB) status — the only thing that decides whether a
 * customer is verified. The backend keeps it on the user
 * (users.kyb_verification_status) and returns it from GET
 * user_verification_status; KycSlice stores it as
 * state.usersection.kyb_verification_status.
 *
 * Only "approved" may book. Every other status gets its own ribbon
 * (components/common/KycStatusRibbon.jsx).
 */

export const KYB_STATUS = Object.freeze({
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  IN_REVIEW: "in_review",
  DOCUMENTS_REQUESTED: "documents_requested",
  APPROVED: "approved",
  PAUSED: "paused",
  DECLINED: "declined",
});

export const KYB_PATH = "/user/business-verification";

// Roles that must pass KYB themselves (KAM / admins book on their behalf).
export const KYB_GATED_ROLES = ["customer", "customer_admin"];

export const isKybApproved = (status) => status === KYB_STATUS.APPROVED;

// Error codes the booking routes answer with while KYB isn't approved.
export const KYB_BOOKING_ERROR_CODES = ["KYB_NOT_VERIFIED", "KYB_IN_REVIEW", "KYB_BOOKINGS_PAUSED", "KYB_STATUS_UNAVAILABLE"];
